import dayjs from 'dayjs';

export function getLastDayOfMonth (date: string, format: string = 'DD.MM.YYYY'): string | null {
  if (!date) {
    return null;
  }

  return dayjs(`01.${date}`, format).endOf('month').format(format);
}
